import { useState } from 'react';
import { message } from 'antd';

function useCopyToClipboard(timeout = 3000) {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (
    text: string,
    successMessage = 'Texto copiado!',
    errorMessage = 'Falha ao copiar o texto.',
  ) => {
    if (isCopied) return;

    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      message.success(successMessage);

      setTimeout(() => {
        setIsCopied(false);
        message.destroy();
      }, timeout);
    } catch (err) {
      setIsCopied(false);
      message.destroy();
      message.error(errorMessage);
    }
  };

  return { isCopied, copyToClipboard };
}

export default useCopyToClipboard;
